import React from 'react'
import { Navigate, useLocation } from "react-router-dom";

import {
  getLoginToken,
  removeLoginToken,
} from '@/utils/localStorage';
import changeName from '@/utils/changeName';
import { checkTokenIsValid, getPageQuery } from '@/utils/utils';
import useEntryPath from '@/hooks/useEntryPath';

const RouteGuard = (props) => {
  const location = useLocation();
  const { getEntryPath } = useEntryPath();
  console.log('getEntryPath', getEntryPath());

  // 不同端的登录路由
  const loginRoute = {
    client: getEntryPath() || '/client/login-with-register',
    therapist: '/therapist/login',
    admin: '/admin/login',
    robot: getEntryPath() || '/client/robot/login',
  }
  const { pathname, search } = location;
  // 拿到子组件,router的参数
  const { role, children } = props

  // 获取token，校验token是否有效，路由是否需要拦截
  const token = getLoginToken(changeName(role));
  const isTokenValid = checkTokenIsValid(token);
  if (!isTokenValid) {
    removeLoginToken(changeName(role));
    return <Navigate to={loginRoute[role]} state={{ from: `${pathname}${search}` }} replace={true}></Navigate>
  }

  return <>{children}</>
}
export default RouteGuard
